var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cabinet-modal" }, [
    _c(
      "div",
      { staticClass: "bg bg--white pa pa--f_sm pa--f_md-md pa--f_lg-lg" },
      [
        _c(
          "text-bemto",
          {
            staticClass: "ma ma--b_md",
            attrs: {
              cfg: "center",
              fw: "bold",
              lh: "small",
              fs: "xl",
              color: "black",
              tag: "p"
            }
          },
          [_vm._v(_vm._s(_vm.title))]
        ),
        _c(
          "text-bemto",
          {
            staticClass: "cabinet-modal__timer",
            attrs: {
              cfg: "center",
              fw: "bold",
              lh: "small",
              fs: "xl",
              color: "black",
              tag: "p"
            }
          },
          [_vm._v(_vm._s(_vm.currentTime))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59253418", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59253418","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Modals/RedirectModal.vue
// module id = 910
// module chunks = 0